<template>
    <div>
        <v-container fluid>
            <v-banner single-line sticky>
                <v-alert
                    color="blue-grey darken-3"
                    dense
                    border="bottom"
                    type="primary"
                    icon="mdi-information"
                >
                    <v-row no-gutters>
                        <v-col cols="4">OPEN NEW CASE</v-col>
                        <v-col cols="4" class="text-center">
                            <v-chip
                                v-if="showpartners != ''"
                                class="orange darken-2"
                                dark
                            >
                                <h3 class="ma-3">{{ showpartners }}</h3>
                            </v-chip>
                            <v-chip
                                v-if="showproject != ''"
                                class="orange darken-2 ml-2"
                                dark
                            >
                                <h3 class="ma-3">{{ showproject }}</h3>
                            </v-chip>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn
                                v-if="!visible"
                                class="ma-0"
                                @click="back()"
                                tile
                                color="cyan darken-1"
                                dark
                                small
                                >Back</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-alert>
            </v-banner>
            <v-row v-if="visible">
                <v-col cols="12" sm="4">
                    <v-card
                        @click="getPartner()"
                        class="mx-auto"
                        max-width="344"
                        filled
                    >
                        <v-card-text>
                            <v-container>
                                <h1>CHOOSE PROJECT</h1>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="2"></v-col>
                <!-- <v-col cols="8" sm="4">
          <v-file-input
            v-model="files"
            color="blue darken-4"
            counter
            label="อัพโหลดไฟล์ case"
            multiple
            small-chips
            placeholder="Select your files"
            prepend-icon="mdi-paperclip"
            :show-size="1000"
            @change="onFileSelected"
          ></v-file-input>
        </v-col>
        <v-col cols="4" sm="2">
          <v-btn
            :loading="loading2"
            :disabled="loading2"
            color="blue-grey"
            class="white--text"
            fab
            @click="UploadFiles()"
          >
            <v-icon dark>mdi-file-upload-outline</v-icon>
          </v-btn>
        </v-col>-->
                <v-col :cols="12" v-if="data_case.total > 0">
                    <v-alert
                        dense
                        border="bottom"
                        type="primary"
                        icon="mdi-information"
                        >CASE TODAY</v-alert
                    >
                    <table-view-case
                        :casetab="casetab"
                        :condition="condition"
                        :data_case="data_case"
                    />
                    <div class="text-center pa-5">
                        <v-pagination
                            @input="onPageChange"
                            v-model="pagination.current"
                            :length="data_case.last_page"
                            circle
                        ></v-pagination>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="!visiblepartner">
                <v-col v-for="(item, idx) in partners" :key="idx" :cols="3">
                    <v-card
                        @click="getProject(item.partner_id, item.partner_name)"
                        class="mx-auto"
                        max-width="344"
                        filled
                    >
                        <v-card-text>
                            <v-container>
                                <h1>{{ item.partner_name }}</h1>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="!visibleproject">
                <v-col v-for="(item, idx) in projects" :key="idx" :cols="3">
                    <v-card
                        @click="selectProject(item.project_id)"
                        class="mx-auto"
                        max-width="344"
                        filled
                    >
                        <v-card-text>
                            <v-container>
                                <h3>{{ item.project_name }}</h3>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="!visibleproblem">
                <v-col v-for="(item, idx) in problemgroup" :key="idx" :cols="3">
                    <v-card
                        @click="selectProblem(item.problem_group_id)"
                        class="mx-auto"
                        max-width="344"
                        filled
                    >
                        <v-card-text>
                            <v-container>
                                <h3>{{ item.problem_group_name }}</h3>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <div v-if="!visiblecase">
                <v-card>
                    <v-form ref="form" v-model="information.valid">
                        <v-information
                            :condition="condition"
                            :information="information"
                        />
                        <!-- <case-information
              :condition="condition"
              :information="information"
            />
            <product-information
              :condition="condition"
              :information="information"
            />
            <customer-information
              :condition="condition"
              :information="information"
            /> -->
                        <engineer-information
                            @showform="validateform()"
                            :condition="condition"
                            :information="information"
                        />
                        <part-information
                            ref="partinfor"
                            :condition="condition"
                            :information="information"
                        />
                    </v-form>
                    <!-- <log-information
                        :condition="condition"
                        :information="information"
          />-->
                    <v-row justify="center">
                        <v-btn
                            :disabled="!information.valid"
                            @click="checktoner()"
                            class="ma-4"
                            tile
                            color="success"
                        >
                            <v-icon left>mdi-content-save</v-icon>Save
                        </v-btn>
                        <!-- <v-btn class="ma-4" tile color="warning">
              <v-icon left>mdi-close-octagon</v-icon>Cancel
            </v-btn>-->
                    </v-row>
                </v-card>
            </div>
        </v-container>
    </div>
</template>

<script>
import axios from "axios"
import firebaseApp from "../../../firebase"

import { mapState, mapMutations } from "vuex"

import TableViewCase from "../components/TableViewCase"
import CaseInformation from "../components/CaseInformation"
import ProductInformation from "../components/ProductInformation"
import CustomerInformation from "../components/CustomerInformation"
import EngineerInformation from "../components/EngineerInformation"
import EngineerNewInformation from "../components/EngineerNewInformation"
import PartInformation from "../components/PartInformation"
import LogInformation from "../components/LogInformation"

import Information from "../components/Information"

export default {
    components: {
        "table-view-case": TableViewCase,
        "case-information": CaseInformation,
        "customer-information": CustomerInformation,
        "product-information": ProductInformation,
        "engineer-information": EngineerNewInformation,
        "part-information": PartInformation,
        "log-information": LogInformation,
        "v-information": Information,
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    data() {
        return {
            casetab: false,
            condition: {
                team: "NONHP",
                status: "ViewDetail",
            },
            information: {
                case_title: "",
                case_type: "",
                case_csr: "",
                case_problem_type: "",
                case_sla: "",
                case_refer: "",
                case_sla_date: "",
                case_sla_time: "",
                remark: "",
                subcase_title: "",
                customer_name: "",
                customer_tel: "",
                customer_email: "",
                site_name: "",
                site_address: "",
                site_postcode: "",
                site_district_id: "",
                site_amphur_id: "",
                site_province_id: "",
                log_type: "",
                log_note: "",
                product_group: "",
                product_line: "",
                product_no: "",
                product_serial: "",
                product_description: "",
                branch_id: "",
                engineer: "",
                part: [],
                clearbyphone: false,
                sla_new: [],
                case_create_date: "",
                case_create_time: "",
            },
            defaultInformation: {
                case_title: "",
                case_type: "",
                case_csr: "",
                case_problem_type: "",
                case_sla: "",
                case_refer: "",
                case_sla_date: "",
                case_sla_time: "",
                remark: "",
                subcase_title: "",
                customer_name: "",
                customer_tel: "",
                customer_email: "",
                site_name: "",
                site_address: "",
                site_postcode: "",
                site_district_id: "",
                site_amphur_id: "",
                site_province_id: "",
                log_type: "",
                log_note: "",
                product_group: "",
                product_line: "",
                product_no: "",
                product_serial: "",
                product_description: "",
                branch_id: "",
                engineer: "",
                part: [],
                clearbyphone: false,
            },
            partners: [],
            company: "",
            visible: true,
            projects: [],
            problemgroup: [],
            visibleproblem: true,
            visibleproject: true,
            visiblepartner: true,
            selectedproject: [],
            visiblecase: true,
            showproject: "",
            showpartners: "",
            data_case: [],
            pagination: {
                current: 1,
            },
        }
    },
    mounted() {
        this.getOwnerTodayCase()
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        validateform() {
            this.$refs.form.validate()
        },
        onPageChange() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
            this.getOwnerTodayCase()
        },
        async getOwnerTodayCase() {
            this.casetab = false
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/owner-case-today?page=${this.pagination.current}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.pagination.current = data.current_page
                this.data_case = data
                this.casetab = true
            } catch (error) {
                console.log(error)
            }
        },
        back() {
            if (this.visiblepartner === false) {
                this.visible = true
                this.visiblepartner = true
            } else if (this.visibleproject === false) {
                this.visiblepartner = false
                this.visibleproject = true
                this.visibleproblem = true
            } else if (
                this.visiblepartner === true &&
                this.visibleproject === true &&
                this.visible === false
            ) {
                this.visiblepartner = true
                this.visibleproject = false
                this.visibleproblem = true
                this.visiblecase = true
                this.showpartners = ""
                this.showproject = ""
                this.information = { ...this.defaultInformation }
            }
        },
        async getPartner() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/getpartners`
            try {
                const { data } = await axios.get(`${url}`)
                this.partners = data

                this.visible = false
                this.visiblepartner = false
            } catch (error) {
                console.log(error)
            }

            this.company = val
        },

        async getProject(partner, partner_name) {
            this.showpartners = partner_name
            this.partners.map((each) => {
                if (each.partner_id == partner) {
                    this.projects = each.projects
                }
            })

            this.visiblepartner = true
            this.visibleproject = false
        },
        selectProblem(problem_group_id) {
            this.information.problem_group_id = problem_group_id
            this.visiblecase = false
            this.visibleproblem = true
        },
        selectProject(project_id) {
            this.selectedproject = project_id
            this.visibleproject = true
            this.information.project_id = project_id

            this.projects.map((each) => {
                if (project_id == each.project_id) {
                    this.problemgroup = each.problem_group
                }
            })

            if (this.problemgroup.length == 0) {
                this.information.problem_group_id = 0
                this.visiblecase = false
            } else {
                this.visibleproblem = false
            }

            this.projects.map((each) => {
                if (each.project_id == project_id) {
                    this.condition.project = each.project_name
                    this.showproject = each.project_name
                    this.information.sla_new = [
                        ...each.sla.map((res) => {
                            return res.sla
                        }),
                    ]
                }
            })
            // this.information.problem_group_id = 4;
            // this.visiblecase = false;
        },
        checktoner() {
            if (
                this.information.part.length == 1 &&
                this.information.category_id == "3" &&
                this.information.case_problem_type != "3" &&
                this.information.project_id == "54"
            ) {
                this.$swal({
                    title: "problem type ไม่ใช่ toner ?",
                    text: "",
                    icon: "warning",
                    buttons: true,
                    primaryMode: true,
                }).then((confirm) => {
                    if (confirm) {
                        this.saveCase()
                    } else {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        })
                    }
                })
            } else {
                this.saveCase()
            }
        },
        async saveCase() {
            this.defaultInformation.problem_type = [
                ...this.information.problem_type,
            ]
            if (this.information.engineer == "ZONE") {
                this.information.dateonsite = ""
            }
            this.information.case_sla_datetime =
                this.information.case_sla_date +
                " " +
                this.information.case_sla_time

            this.information.case_create_datetime =
                this.information.case_create_date +
                " " +
                this.information.case_create_time
            const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/newcase`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                this.mutateIsLoading()
                let { data, status } = await axios
                    .post(url, this.information, options)
                    .catch(function(error) {
                        swal({
                            title: `Error Message : ${error}`,
                            icon: "error",
                            button: "OK",
                        })
                    })
                this.mutateIsLoading()
                if (status == "200") {
                    this.$swal({
                        title:
                            "บันทึกข้อมูลเรียบร้อย เปิดเคสต่อไปใน project เดิมหรือไม่ ?",
                        text: "",
                        icon: "success",
                        buttons: true,
                        dangerMode: true,
                    }).then((del) => {
                        if (del) {
                            this.information = {
                                project_id: this.selectedproject,
                                dateonsite: "",
                                ...this.defaultInformation,
                            }
                            window.scrollTo(0, 0)
                            this.information.case_type = "Onsite Repair"
                            this.information.case_csr = "C"
                            this.information.case_sla = "NBD"
                            this.$refs.partinfor.delpart()
                        } else {
                            this.visible = true
                            this.visiblepartner = true
                            this.visibleproject = true
                            this.visiblecase = true
                            this.showproject = ""
                            this.information = { ...this.defaultInformation }
                            this.getOwnerTodayCase()
                        }
                    })
                }
            } catch (error) {
                console.log(error.message)
            }

            //   var contactRef = firebaseApp.database().ref(`contacts/${this.information.ReferCase}`)
            //   contactRef.set({
            //         casetitle: this.information.casetitle,
            //         jobtype: this.information.jobtype,
            //         proptype : this.information.Probtype
            //   })
        },
    },
}
</script>

<style>
.v-banner__text {
    width: 1150px;
}
</style>
